const csvEscape = (value) => {
  const text = value == null ? "" : String(value);
  if (/[",\n\r]/.test(text)) {
    return `"${text.replace(/"/g, '""')}"`;
  }
  return text;
};

const joinList = (values) => (Array.isArray(values) ? values.join("; ") : "");

const SURVEY_HEADERS = [
  "Submitted At",
  "Student Name",
  "Email",
  "Exam Types",
  "Age Range",
  "Heard About",
  "Heard About Other",
  "Usage Frequency",
  "Main Uses",
  "Main Uses Other",
  "Device",
  "Device Other",
  "Satisfaction",
  "Ease Of Use",
  "Most Value",
  "Most Value Other",
  "Biggest Challenge",
  "Biggest Challenge Other",
  "Technical Problems",
  "Technical Problems Other",
  "Likes Most",
  "Improve One Thing",
  "Study Plan Usefulness",
  "Subscription Willingness",
  "Not Subscribe Reason",
  "Not Subscribe Reason Other",
  "Recommend Score",
  "Return Weekly",
  "Use Daily",
  "One Sentence Description",
  "Source",
];

export const exportSurveysToCsv = (surveys = []) => {
  const rows = surveys.map((survey) => [
    survey.createdAt ? new Date(survey.createdAt).toISOString() : "",
    survey.userName || "",
    survey.userEmail || "",
    joinList(survey.examTypes),
    survey.ageRange || "",
    survey.heardAbout || "",
    survey.heardAboutOther || "",
    survey.usageFrequency || "",
    joinList(survey.mainUses),
    survey.mainUsesOther || "",
    survey.device || "",
    survey.deviceOther || "",
    survey.satisfaction || "",
    survey.easeOfUse || "",
    survey.mostValue || "",
    survey.mostValueOther || "",
    survey.biggestChallenge || "",
    survey.biggestChallengeOther || "",
    joinList(survey.technicalProblems),
    survey.technicalProblemsOther || "",
    survey.likesMost || "",
    survey.improveOneThing || "",
    survey.studyPlanUsefulness || "",
    survey.subscriptionWillingness || "",
    survey.notSubscribeReason || "",
    survey.notSubscribeReasonOther || "",
    survey.recommendScore ?? "",
    survey.returnWeekly || "",
    survey.useDaily || "",
    survey.oneSentenceDescription || "",
    survey.source || "",
  ]);

  const csv = [SURVEY_HEADERS, ...rows].map((row) => row.map(csvEscape).join(",")).join("\r\n");
  const blob = new Blob(["\uFEFF" + csv], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = `ots-user-surveys-${new Date().toISOString().slice(0, 10)}.csv`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
};
